var lib_core = require("lib-core");

var ComponentMetaData = require("./componentMetaData.js");
var ComposedSymbolData = require("./composedSymbolData.js");

var ComponentData = function (initializeNew) {
    var self = this;
    this.makeObservableTreeNode();

    this.metaData = this.value("metaData", true);

    // abstract component interface
    this.logicTerminals = this.set("logicTerminals", true);   // contains set of logicTerminalData
    this.terminalNames = new lib_core.NameManager();
    var uniqueNameValidator = function(name){
        return name != undefined && !self.terminalNames.isRegistered('', name);
    };
    this.logicTerminals.onAdd("nameManager", function(logicTerminalData){
        if (self.terminalNames.isRegistered('', logicTerminalData.name())) logicTerminalData.name(self.terminalNames.getProposal('', logicTerminalData.name())); // if name of added symbolInstance already exist propose a new unique name
        self.terminalNames.register('', logicTerminalData.name());
        logicTerminalData.name.onChange("nameManager", function(name, old){
            self.terminalNames.remove('', old);
            self.terminalNames.register('', name);
        });
        logicTerminalData.name.validator = uniqueNameValidator;
    });
    this.logicTerminals.onRemove("nameManager", function(logicTerminalData){
        self.terminalNames.remove('', logicTerminalData.name());
        logicTerminalData.name.removeHandlers("nameManager");
        logicTerminalData.name.validator = null;
    });

    this.properties = this.list("properties", true);          // contains ordered list of propertyData

    // different models of component which contains terminalMappings to above logic terminals:
    this.composedSymbol = this.value("composedSymbol", true); // contains composedSymbolData
    this.packageInstances = this.list("packageInstances", true);  // ordered list of packages
    this.breadboard = this.value("breadboard", true);   // contains breadboardData
    this.breadboard(null); //required for closure compiler

    //this.simulationModel = this.value("simulationModel", true); // contains simulationData
    this.simulationModelName = this.value("simulationModelName", true);    // for now: name of internal simulation model
    this.simulationModelName(null); //required for closure compiler

    this.isComplete = this.shadow("isComplete",
        function() {
            return self.composedSymbol().symbolInstances.size() !== 0
                || self.packageInstances.size() !== 0;
        }, null,
        [[this, this.onBubble]]
    );

    if(initializeNew) {
        var metaData = new ComponentMetaData();
        metaData.name("New Component");
        metaData.summary("");
        metaData.description("");
        metaData.prefix("U");
        this.metaData(metaData);

        this.composedSymbol(new ComposedSymbolData());
    }

    this.onInit("initialize", this.initialize, 10);
};
lib_core.mixin(ComponentData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(ComponentData, "ComponentData");
module.exports = ComponentData;

//ComponentData.prototype.generateDescription = function() {
//    return JSON.stringify(this.jsonify());
//};

ComponentData.prototype.initialize = function(){
    this.buildInverseTerminalMap();
};

// TODO: make abstract index class
ComponentData.prototype.buildInverseTerminalMap = function(){
    var self = this;
    this.inverseTerminalMap = new lib_core.Collections.HashMap();   // TODO: ideally this is an observable non-persistent field

    // make a map for each logicTerminal
    this.logicTerminals.forEach(function(logicTerminal){
        self.inverseTerminalMap.put(logicTerminal, new lib_core.Collections.HashSet());
    });
    this.logicTerminals.onAdd("inverseMapBuilder", function(logicTerminal){
        self.inverseTerminalMap.put(logicTerminal, new lib_core.Collections.HashSet());
    });
    this.logicTerminals.onRemove("inverseMapBuilder", function(logicTerminal){
        self.inverseTerminalMap.remove(logicTerminal);
    });

    // add terminals
    var addObj = function(obj){
        obj.terminalMap.forEach(function(terminal, logicTerminal){
            self.inverseTerminalMap.get(logicTerminal).add(terminal);
        });
        obj.terminalMap.onPut(self, function(terminal, logicTerminal, old_logicTerminal){
            if (self.inverseTerminalMap.contains(old_logicTerminal)) self.inverseTerminalMap.get(old_logicTerminal).remove(terminal);
            self.inverseTerminalMap.get(logicTerminal).add(terminal);
        });
        obj.terminalMap.onRemove(self, function(terminal, logicTerminal){
            if (self.inverseTerminalMap.contains(logicTerminal)) self.inverseTerminalMap.get(logicTerminal).remove(terminal);
        });
    };

    var removeObj = function(obj){
        obj.terminalMap.forEach(function(terminal, logicTerminal){
            self.inverseTerminalMap.get(logicTerminal).remove(terminal);
        });
    };

    // check symbol mappings:
    this.composedSymbol().symbolInstances.forEach(function(symbolInstance){
        addObj(symbolInstance);
    });
    this.composedSymbol().symbolInstances.onAdd(self, function(symbolInstance){
        addObj(symbolInstance);
    });
    this.composedSymbol().symbolInstances.onRemove(self, function(symbolInstance){
        removeObj(symbolInstance);
    });

    // check footprint mapping
    this.packageInstances.forEach(function(idx, packageInstance){
        if(!packageInstance.isObservableTreeNode) return; // cannot build inverse map if data is not loaded.
        addObj(packageInstance);
    });
    this.packageInstances.onAdd(self, function(idx, packageInstance){
        addObj(packageInstance);
    });
    this.packageInstances.onPut(self, function(idx, packageInstance, old_packageInstance){
        if (old_packageInstance) removeObj(packageInstance);
        addObj(packageInstance);
    });
    this.packageInstances.onRemove(self, function(idx, packageInstance){
        removeObj(packageInstance);
    });
};
